import { BaseModel, convertToArrayModels, fillOwnProperties } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import LandingAdvantagesItem from './LandingAdvantagesItem'

export default class LandingAdvantagesBlock extends BaseModel {
  static override constructorName = 'LandingAdvantagesBlock'

  readonly name = 'advantages_block'

  title: string = ''
  text: string = ''
  items: LandingAdvantagesItem[] = []

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data, ['items'])

      this.items = convertToArrayModels(data.items, LandingAdvantagesItem)
    }
  }
}
